<div
  class="flex justify-start items-center credits-badge rounded-full w-auto"
  [ngClass]="{
    'pl-1 pr-2 mt-0.5': !basePanelService.routeData.shortLeftNavigation,
    'mt-2 py-1 px-2': basePanelService.routeData.shortLeftNavigation
  }"
  [tuiHint]="'You will use 1 credit per one generated piece of content or graphic.'"
>
  <img
    *ngIf="!basePanelService?.routeData?.shortLeftNavigation"
    src="assets/img/credits-badge.png"
    class="w-5 h-5 object-contain"
    alt="coin"
  />
  <span
    class="tui-text-body-xs font-bold"
    *ngIf="userService.credits$ | async as credits"
  >
    <ng-container
      *ngIf="!!credits && credits > 9999 && basePanelService?.routeData?.shortLeftNavigation; else fullCredits"
    >
      <div *ngIf="credits < 90000000">+10k</div>
      <div *ngIf="credits > 90000000">&infin;</div>
    </ng-container>
    <ng-template #fullCredits>
      <div *ngIf="credits < 90000000">{{ userService.credits$ | async }}</div>
      <div *ngIf="credits > 90000000">&infin;</div>
    </ng-template>
  </span>
</div>
